import { Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';
import { JSX } from 'react';

import * as S from './styled';

const Step = ({
    stepNumber,
    children,
    dataLocator,
}: {
    stepNumber: number;
    children: JSX.Element;
    dataLocator: string;
}) => {
    const { t } = useTranslation();

    return (
        <S.Container
            $backgroundColor="surface-secondary"
            $borderRadius={16}
            $paddingX={12}
            $paddingTop={26}
            $paddingBottom={24}
            dataLocator={dataLocator}
        >
            <S.StepNumber
                $backgroundColor="surface-main"
                $borderRadius={20}
                $borderColor="border-default"
                $paddingBottom={8}
                $paddingTop={8}
                $paddingX={16}
            >
                <Text type="overline">{t('main.step.number', { count: stepNumber })}</Text>
            </S.StepNumber>
            {children}
        </S.Container>
    );
};

export default Step;
